module.exports = __webpack_public_path__ + "img/Weapon_147.397bc936.png";